<app-card-criteria-form (criteria)="onSearch($event)"></app-card-criteria-form>
<app-card-list #list [sorting]="sorting" (page)="onScroll()" (sort)="onSort($event)"></app-card-list>
